import { type ReactNode } from 'react';
import { RequiredLabel } from '@gonfalon/ui/RequiredLabel';
import type { TextFieldProps } from '@launchpad-ui/components';
import { TextField as LaunchpadTextField, Text, TextArea } from '@launchpad-ui/components';

import { FormFieldError } from './FormFieldError';
import {
  type BrowserExtensionControlProps,
  getDisableBrowserExtensionAttributes,
} from './getDisableBrowserExtensionAttributes';
import { useField } from './useField';

export type FormTextAreaFieldProps = TextFieldProps &
  BrowserExtensionControlProps & {
    label?: ReactNode;
    description?: ReactNode;
    placeholder?: string | undefined;
    rows?: number;
    cols?: number;
    updateOnBlur?: boolean;
  };

export function TextAreaInputField({
  label,
  description,
  placeholder,
  updateOnBlur,
  isRequired,
  disableBrowserExtensions = true,
  ...props
}: FormTextAreaFieldProps) {
  const { field, ...fieldProps } = useField<string>({ updateOnBlur, ...props });

  return (
    <LaunchpadTextField name={field.name} isRequired={isRequired} {...props} {...fieldProps}>
      {label && <RequiredLabel isRequired={isRequired}>{label}</RequiredLabel>}
      {description && <Text slot="description">{description}</Text>}
      <TextArea
        placeholder={placeholder}
        rows={props.rows}
        cols={props.cols}
        {...getDisableBrowserExtensionAttributes(disableBrowserExtensions)}
      />
      <FormFieldError meta={field.state.meta} />
    </LaunchpadTextField>
  );
}
